import type { ConsoleRoute } from '../index';
import { SponsorReportsPage } from './SponsorReportsPage';

export const sponsorReportsRoutes: ConsoleRoute[] = [
  {
    path: 'sponsor-reports',
    handle: { permission: 'sponsor.report.view', title: 'Sponsor reporting' },
    element: <SponsorReportsPage />,
  },
];
